import React from "react";
import CustomLink from "../UI/CustomLink";
import styles from "@/styles/CardModel.module.scss";
import { CardModelProps } from "@/app/interface/components";

const CardModel: React.FC<CardModelProps> = ({ name, img, href }) => {
	return (
		<CustomLink
			className={styles.main}
			href={`https://gabcomercio.azureedge.net/azul-agro/downloads${href}.pdf`}
			target="_blank"
		>
			<img src={img} alt="" width={160} height={160} loading={"lazy"} />
			<span>{name}</span>
			<CustomLink
				target="_blank"
				className="btn-secondary"
				href={`https://gabcomercio.azureedge.net/azul-agro/downloads${href}.pdf`}
			>
				Ficha Técnica
			</CustomLink>
		</CustomLink>
	);
};

export default React.memo(CardModel);
